import React, { useMemo } from "react";
import Header from "../../layout/header";
import { Card, CardContent, Link, Grid, Button } from "@mui/material";
import {AddCircleOutline} from '@mui/icons-material';
import Preview from "../template/previews/Preview"
import Preview1 from "../template/previews/Preview1"
import Preview2 from "../template/previews/Preview2"
import Preview3 from "../template/previews/Preview3"
import Preview4 from "../template/previews/Preview4"
import Preview5 from "../template/previews/Preview5"
import Preview6 from "../template/previews/Preview6"
import { useNavigate } from "react-router-dom";

const Dashboard = () =>{
    const navigate = useNavigate();
    let savedTemplates = localStorage.getItem('savedTemplates') ? JSON.parse(localStorage.getItem('savedTemplates')) : []
    const templates = useMemo(() => ({
        1: Preview,
        2: Preview1,
        3: Preview2,
        4: Preview3,
        5: Preview4,
        6: Preview5,
        7: Preview6
      }), []);

    const handleSelectedTemplate = (templ) =>{
        localStorage.setItem("fieldValues", JSON.stringify(templ['values']))
        localStorage.setItem('template', parseInt(templ.template))
        localStorage.setItem('color',JSON.stringify(templ['color']))
        navigate('/create')
    }

    const handleNew = (templ) =>{
        localStorage.removeItem("fieldValues")
        localStorage.removeItem('template')
        localStorage.removeItem('color')
        localStorage.removeItem('fieldValues')
        navigate('/template')
    }

    return <>
    <Header />
    {savedTemplates.length  === 0 ? <Card sx={{ maxWidth: 275,display:'grid', alignItems:'center', textAlign: 'center', margin: '50px', height: '200px' }}>
        <CardContent onClick={()=>handleNew()}>
                <AddCircleOutline sx={{width:'3em', height:'2em'}}/>
        </CardContent>
    </Card> :  <Grid container xs={12} p={5} >
           <Button variant="contained" onClick={()=>handleNew()}>Create</Button>
        </Grid>}
    <Grid container px={5} xs={12}>    
        <Grid container xs={12} gap={3} height={'50%'}>
            {savedTemplates.length ? savedTemplates.map((templ)=>{
            const SelectedPreview = templates[parseInt(templ.template)] || null;
                return SelectedPreview ?  <Grid item px={2} xs={3} onClick={()=>handleSelectedTemplate(templ)}>
                    <Card variant="outlined"  sx={{ height: '100%'}}>
                        <SelectedPreview fieldValues={templ['values']} selectedColor={templ['color']} fullHeight={true} page={'template'} />  : ''
                    </Card>
                </Grid>  : ''
            }) : ''}
        </Grid>
    </Grid>
   
   
    </>
}

export default Dashboard